import { BIModel } from './BIModel';
export class UserAlertAbandonBIModel extends BIModel {

  static eventName = 'user_alert_abandon';

  #flow;
  #brand;
  #size;
  #status;
  #price;
  
  constructor(userId, flow, brand, size, status, price) {
    super(UserAlertAbandonBIModel.eventName, userId);
    this.#flow = flow;
    this.#brand = brand;
    this.#size = size;
    this.#status = status;
    this.#price = price;
  }

  get flow() {
    return this.#flow;
  }

  get brand() {
    return this.#brand;
  }

  get size() {
    return this.#size;
  }

  get status() {
    return this.#status;
  }

  get price() {
    return this.#price;
  }

  get modelData() {
    return {
      flow: this.flow,
      brand: this.brand,
      size: this.size,
      status: this.status,
      price: this.price
    };
  }

}